import ReplacementList from './ReplacementList';

export default ReplacementList;
